import { useEffect, useState } from 'react';
import { getReferentialByType, ProductGroup, ReferentialType } from './Referentials/Referentials';
import { Referential } from './Cache/Cache';

const useReferential = <T extends Referential = Referential>(
	type: ReferentialType,
	group: ProductGroup = 'MONEY',
): [boolean, T[]] => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState<T[]>([]);

	useEffect(() => {
		getReferentialByType(type, group)
			.then((b) => {
				setData(b as T[]);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [type, group]);
	return [loading, data];
};

export default useReferential;
